import React from 'react';
import { AdContext } from '.';
import AdServiceContext from '../services/context';

export function withAds(Component: any) {
  const wrapper = (props: any, ref: React.Ref<any>) => {
    return (
      <AdContext.Consumer>
        {adContext => (
          <AdServiceContext.Consumer>
            {adServiceContext => (
              <Component
                {...props}
                ref={ref}
                adContext={adContext}
                adServiceContext={adServiceContext}
              />
            )}
          </AdServiceContext.Consumer>
        )}
      </AdContext.Consumer>
    );
  };

  return React.forwardRef(wrapper);
}
